export default __webpack_public_path__ + "static/media/product7.6b54a9e5.jpg";